import "./style.scss"
import {  useUpdateDealerMutation } from "../../store";
import { useState, useEffect } from "react";
import MainHeader from "../../Components/MainHeader/MainHeader";
import UpdatePopup from "./UpdatePopup";
import axios from "axios";
import 'tippy.js/dist/tippy.css';
import { BaseURL } from "../../Essentials/variables";
import {  OverlayTrigger } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import './DealerManagementSystem.css';
import { useNotify } from "../../Components/Notifications/NotificationContext";
import { Hourglass } from "react-loader-spinner";
// import{ BaseURL} from  "../../Essentials/variables";

const axiosFetch = axios.create();
axiosFetch.defaults.headers.common['X-Frame-Options'] = 'DENY';
axiosFetch.defaults.headers.common['Content-Security-Policy'] = "frame-ancestors 'none'";
axiosFetch.defaults.headers.common['Feature-Policy'] = "frame-ancestors 'none'";

function DealerManagementSystem(props) {
  
  const notify = useNotify();
  const [updateDealer, updateDealerResults] = useUpdateDealerMutation();
  const [showPopup, setShowPopup] = useState(false);
  const [userData, setUserData] = useState({});
  const [filter, setFilter] = useState("employee");
  const [dealerInfoState, setDealerInfoState] = useState('Loading...');
  const [dealerInfoState2, setDealerInfoState2] = useState('Loading...');
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);

  const [userIds, setUserIds] = useState([]);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState([])
  const [dataRefresh, setDataRefresh] = useState(false)

  const dealerInfo = ({ item, placement, scheduleUpdate, arrowProps, outOfBoundaries, show, ...props }) => (
    <div
      {...props}
      style={{
        // backgroundImage: 'linear-gradient(rgba(7,10,82,0.3), rgba(7,10,82,0.3)), url(loginbg.jpg)',
        // backgroundColor: 'rgba(7,10,82,1)',
        backgroundColor: '#171C8F',
        padding: '2px 10px',
        color: 'white',
        borderRadius: 3,
        ...props.style,
      }}
    >
      <ul style={{ "listStyle": "none", "marginLeft": "-30px", "paddingTop": "5px", "display": "flex", "flexDirection": "column", "justifyContent": "space-evenly", "zIndex": "99" }}>
        <li><h6>Parent Group Name:{' '}{(dealerInfoState !== '' && dealerInfoState) ? dealerInfoState : 'Not Available'}</h6></li>
        <li><h6>Employee Designation:{' '}{(dealerInfoState2 !== '' && dealerInfoState2) ? dealerInfoState2 : 'Not Available'}</h6></li>
        {/* <li><h6>Last Census Refresh : 2022-10-02</h6></li>
      <li><h6>Last Potential Refresh : 2023-01-16</h6></li> */}
      </ul>

    </div>
  );




  const handleAddUserButton = () => {
    setUserData({});
    setShowUpdatePopup(true);
  }


  const handleClosePopup = () => {
    window.location.reload();
    setShowPopup(false);

  };

  const handleChangeDealerFilter = (e) => {
    console.log(e.target.value);
    setFilter(e.target.value);
  }


  const [searchval, Setsearchval] = useState('');
  const [fdata, setFdata] = useState([]);
  useEffect(() => {
    setLoading(true);
    fetch(`${BaseURL}alldealers`, {
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': localStorage.getItem('token'),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setInitialData([...data]);
        setUserIds(data.map(item => item.user_id));
        // console.log('Data loaded and fdata updated:', fdata);
        return data; // Pass the data to the next .then
      })
      .then((data) => {
        // Log the updated fdata after the state update has likely taken effect
        console.log('Updated fdata:', data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, [dataRefresh]);

  const handleUpdate = (check) => {
    // Update the user details
    setLoading(true)
    console.log('handle update called')
    console.log()
    if (check) {
      // const updatedData = useFetchDealersQuery();
      // console.log('Updated data:', updatedData);
      setDataRefresh((!dataRefresh))
    }
    //  setUser(updatedUser);
  };
  // const saveData = () => {
  //   console.log("Error: ", error);
  //   if (!error) {
  //     data?.map((product) => {
  //       if (fdata) {
  //         setFdata(fdata => [...fdata, product])
  //       }
  //       return fdata;
  //     })
  //   }
  // }
  let Token = localStorage.getItem('token');

  const handleOnClickDelete = (id, type) => {
    const choice = window.confirm('Are you sure you want to delete this user?');
    if (choice) {
      setDeleteLoader(true)
      console.log(id, type);
      axiosFetch({
        method: 'GET',
        headers: {
          "x-access-token": Token,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: false,
        url: BaseURL + `updateuser/v2/${id}`,
      })
        .then((res) => { setDeleteLoader(true); console.log(res); notify.success("Data Deleted successfully!"); window.location.reload(); })
        .catch((err) => console.log(err))
    }

  }
  const handleOnClickUpdate = (id, type) => {
    console.log(id, type);
  }
  const handleOpenUpdatePopup = (item) => {
    // Set the userData or item you want to edit in the popup
    // and then show the popup
    setUserData(item);
    setShowUpdatePopup(true);
  };
  // useEffect(() => {
  //   saveData();

  // }, [isFetching])

  const handleToggle = (id, value, admin, potential, change, Type, report, name) => {
    console.log(id, "->", value, "->", admin, "->", potential, "->", change, "->", Type, "->", report);
    updateDealer({ id, value, admin, potential, change, Type, report });
    let messagePrefix = '';

switch (change) {
  case 'reportaccess':
    messagePrefix = 'Report access updated successfully';
    break;
  case 'potential':
    messagePrefix = 'Potential access updated successfully';
    break;
  case 'access':
    messagePrefix = 'Coverage access updated successfully';
    break;
  case 'admin':
    messagePrefix = 'Admin access updated successfully';
    break;
  default:
    messagePrefix = 'Data updated successfully';
}
  notify.success(`${messagePrefix} for "${name}"!`);
  }

  useEffect(() => {


    let updatedData = initialData?.filter((data) => {
      return (data?.name?.toLowerCase().includes(searchval?.toLowerCase()) || data?.user_id?.toLowerCase().includes(searchval?.toLowerCase())) && data?.type?.toLowerCase().includes(filter);
    })

    console.log('updated data', updatedData)

    // setFdata(data?.filter((data) => {
    //   return (data?.name?.toLowerCase().includes(searchval?.toLowerCase()) || data?.user_id?.toLowerCase().includes(searchval?.toLowerCase())) && data?.type?.toLowerCase().includes(filter);
    // })
    // )
    setFdata(updatedData)
  }
    , [searchval, initialData, filter]
  )

  const HandleOnchangeSearch = (e) => {
    Setsearchval(e.target.value);
  }
  ///////////////////////////////
  const rows = fdata?.map((item,index) => (
    <tr className="table-td-style bg-slate-600 border-b  dark:border-gray-700 table-rows" key={`${item?.user_id}-${index}`}>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white">{item?.name}</td>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white">{item?.user_id}</td>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white">{item?.accesstype}</td>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white">{item?.accessname}</td>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white" >
        <label className="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" value="" className="sr-only peer" defaultChecked={item?.access === "No" ? false : true} onChange={() => handleToggle(item?.user_id, item?.access, item?.admin, item?.potential, "access", item?.type, item?.reportaccess,item?.name)} />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
      </td>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white" >
        <label className="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" value="" className="sr-only peer" defaultChecked={item?.potential === "No" ? false : true} onChange={() => handleToggle(item?.user_id, item?.access, item?.admin, item?.potential, "potential", item?.type, item?.reportaccess,item?.name)} />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
      </td>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white" >
        <label className="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" value="" className="sr-only peer" defaultChecked={item?.reportaccess === "No" ? false : true} onChange={() => handleToggle(item?.user_id, item?.access, item?.admin, item?.potential, "reportaccess", item?.type, item?.reportaccess,item?.name)} />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
      </td>
      <td className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white" >
        <label className="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" value="" className="sr-only peer" defaultChecked={item?.admin === "No" ? false : true} onChange={() => handleToggle(item?.user_id, item?.access, item?.admin, item?.potential, "admin", item?.type, item?.reportaccess,item?.name)} />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
      </td>

      {/* <td onClick={()=>handleOnClickUpdate(item?.user_id,item?.type,handleOpenPopup(item))} className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white"><i className="bi bi-pencil"></i></td> */}
      <td
        onClick={() => handleOpenUpdatePopup(item)}
        className="px-6 py-2 font-medium text-white-200 whitespace-nowrap"
      >
        <i className="bi bi-pencil cursor-pointer update-icon"></i>
      </td>
      <td onClick={() => handleOnClickDelete(item?.user_id, item?.type)} className="table-td-style px-6 py-2 font-medium text-gray-200 whitespace-nowrap dark:text-white"><i className="bi bi-trash3 cursor-pointer delete-icon"></i></td>
      <td>

        <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={dealerInfo}>
          <div id="user">
            <i style={{ color: '#fff' }} onClick={() => { setDealerInfoState(item.password); setDealerInfoState2(item.employee_desg) }} className='bi bi-info-circle'></i>
            {/* <i style={{color:'#fff' }} onClick={()=>{setDealerInfoState(item.employee_desg)}} className='bi bi-info-circle'></i> */}
          </div>
        </OverlayTrigger>
      </td>
    </tr>
  ));
  // {item?.accessname}     {item?.accessname}
  return (
    <div style={{
      backgroundImage: " url(background.png)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
      // height: "100vh",
      overflowX: "hidden",
      minHeight: "100vh",
    }} className='access-management-main-div'>
      {/* background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed; */}
      <MainHeader  nav={props.nav} />
      {deleteLoader === true && <div className="delete-loader-div">

        <Hourglass
          visible={deleteLoader}
          height="200"
          width="100%"
          ariaLabel="hourglass-loading"
          wrapperStyle={{}}
          wrapperClass=""
          colors={['#fff', '#d3d3d3']}
          className='delete-hourglass'
        />

        <h1 className="delete-record-text">Deleting Record...</h1>
      </div>}
     {deleteLoader===false && <div className="px-12">
        <h3 className="text-slate-200 font-serif flex items-center justify-center">Access Management</h3>
        <button onClick={handleAddUserButton} type="submit" className="text-white float-right  bg-slate-600 hover:bg-slate-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 ">ADD USER</button>
        <br />
        <hr className="w-48 h-1 mx-auto my-4 bg-gray-300 border-0 rounded md:my-10 dark:bg-gray-700"></hr>
        <div className="overflow-x mt-4 relative overflow-x-auto shadow-md sm:rounded-lg">
          {!showPopup && <form className="pb-4 py-4">
            <label className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"></svg>
              </div>
              <div className="flex">
                <select onChange={handleChangeDealerFilter} className="grow-0 mr-10 w-1/6 px-4 py-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  {/* <option key='"dealer" && "employee"' value='"dealer" && "employee"'>All</option> */}
                  <option key="employee" value='employee'>Employee</option>
                  <option key="dealer" value='dealer'>Dealer</option>

                </select>
                <input value={searchval} onChange={HandleOnchangeSearch} type="search" id="default-search" className="grow w-4/6 px-4 py-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search Name/ID/MSPIN..." required />
              </div>
              {/* <button type="submit" className="text-white absolute right-2.5 bottom-2.5 bg-slate-600 hover:bg-slate-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 ">Search</button> */}
            </div>
          </form>}
          {!showPopup && loading && <SkeletonTheme baseColor="#171C8F" highlightColor="#444">
            <p>
              <Skeleton count={10} />
            </p>
          </SkeletonTheme>}

          { !loading &&(<table className="table-auto mb-2 overflow-y-scroll w-full text-sm text-left text-gray-500 dark:text-gray-400">
            {!showPopup && <thead className="text-md table-heading text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr className="bg-slate-600 border-b  dark:border-gray-700 table-rows">
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Name</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">ID/MSPIN</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Access Level</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">State/Type</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Coverage</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Potential</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Report</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Admin</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Update</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">Delete</th>
                <th className="px-6 py-3 font-bold text-gray-100 whitespace-nowrap dark:text-white">More</th>
              </tr>
            </thead>}
            <tbody className="h-fit">
              {!showPopup && loading && <Skeleton count={5} />}
              {!showPopup && !loading && rows}
              {/* {showPopup && (<UpdatePopup onClose={handleClosePopup} onUpdate={handleUpdate} profile={userData} requestfrom='admin'/>)} */}
              {showUpdatePopup && (
                <div className="modal-dealer active">
                  <div className="modal-content">
                    <UpdatePopup
                      onClose={() => setShowUpdatePopup(false)}
                      onUpdate={handleUpdate}
                      profile={userData}
                      requestfrom='admin'
                      userIds={userIds}
                    />
                  </div>
                </div>
              )}
            </tbody>
          </table>)}
        </div>
      </div>}
    </div>
  )
}
//className="px-6 py-3"
export default DealerManagementSystem;



